import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-heart',
  templateUrl: './heart.component.html',
})
export class HeartComponent {
  @Input() width = '10px';
  @Input() height = '10px';
  @Input() fillColor = 'grey';

  constructor() {
  }
}
